import {FC} from 'react'
import {ApolloQueryResult} from '@apollo/client'
import {useQuery} from 'hooks/graphql'
import {useSelector} from 'hooks/redux'
import {useLocation} from 'react-router-dom'
import queryString from 'query-string'
import {useDispatch} from 'react-redux'

import {asyncError} from 'store/actions/asyncError'
import {Presenter} from './Presenter'
import {ALERT_TYPES, UPDATE_ALERT_TYPE_ORDINALS} from './query'
import type {AlertTypesQueryResult, AlertTypesQueryVariables, UpdateAlertTypeOrdinalsQueryResult} from './query'
import {getSavedDisplayAlertTypeLimit} from './utils'

// @ts-ignore
import {useMutation} from 'components/Graphql'

export type Refetch = () => Promise<ApolloQueryResult<AlertTypesQueryResult>>

export const Show: FC = () => {
  const dispatch = useDispatch()

  const user = useSelector((state) => state.session.currentUser)
  const location = useLocation()
  const {pathname, search} = location

  const pageParams = queryString.parse(search)['page']
  const variables: AlertTypesQueryVariables = {
    page: Number(pageParams) || 1,
    per: Number(getSavedDisplayAlertTypeLimit(pathname, user)),
  }

  const {data, refetch, loading} = useQuery<AlertTypesQueryResult>(ALERT_TYPES, {
    variables,
    fetchPolicy: 'network-only',
  })

  const [updateAlertTypeOrdinals] = useMutation<UpdateAlertTypeOrdinalsQueryResult>(UPDATE_ALERT_TYPE_ORDINALS)

  const handleSaveOrdinals = async (idList: number[], ordinalList: number[]) => {
    try {
      await updateAlertTypeOrdinals({
        variables: {
          input: {
            ids: idList,
            ordinals: ordinalList,
          },
        },
        fetchPolicy: 'network-only',
      })
      await refetch()
    } catch (error) {
      dispatch(asyncError(error))
    }
  }

  return (
    <Presenter
      totalCount={data?.alertTypes.totalCount ?? 0}
      alertTypes={data?.alertTypes?.list ?? []}
      refetch={refetch}
      variables={variables}
      handleSaveOrdinals={handleSaveOrdinals}
      loading={loading}
    />
  )
}
